require('instant.page');
require('./livewire/alerts');

import Tooltip from '@ryangjchandler/alpine-tooltip';
import Alpine from 'alpinejs';
import {toastr} from './mixins/toastr';
import AlpineCheckbox from './alpinejs/checkbox';
import AlpineMultiSelect from './alpinejs/multiselect';
import AlpineSelect from './alpinejs/select';

// Register alpinejs tooltips
Alpine.plugin(Tooltip);

// Register custom data functions
document.addEventListener('alpine:init', () => {
    Alpine.data('checkbox', AlpineCheckbox);
    Alpine.data('multiselect', AlpineMultiSelect);
    Alpine.data('select', AlpineSelect);
})

// Toastr globals
window.toastr = toastr;

// Alpine start
window.Alpine = Alpine;
window.Alpine.start();